import classNames from 'classnames';

export interface FunnelCardSkeletonProps {
  titleWidthClass: string;
}

const BAR_PAIR_COUNT = 2;
const BAR_PAIRS = Array.from({ length: BAR_PAIR_COUNT }, (_, index) => index);

const COMPARATOR_ROW_COUNT = 3;
const COMPARATOR_ROWS = Array.from(
  { length: COMPARATOR_ROW_COUNT },
  (_, index) => index
);

const FunnelCardSkeleton = ({ titleWidthClass }: FunnelCardSkeletonProps) => (
  <div
    className="flex w-full flex-col rounded-lg border border-navy-100 bg-white"
    data-testid="funnel-card-skeleton"
  >
    <div className="flex flex-col items-start gap-2 border-b border-navy-100 px-3 pt-2 pb-[9px]">
      <span
        className={classNames('block h-5 rounded bg-gray-200', titleWidthClass)}
      />
    </div>

    <div className="px-3 py-2.5">
      <div className="flex items-center gap-1.5">
        <span className="block h-7 w-16 rounded bg-gray-200" />
        <span className="block h-6 w-14 rounded bg-gray-100" />
      </div>
    </div>

    <div className="flex flex-col gap-4 px-3 py-2">
      {BAR_PAIRS.map((barPair) => (
        <div key={barPair} className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="block h-4 w-24 rounded bg-gray-100" />
            <span className="block h-4 w-10 rounded bg-gray-100" />
          </div>
          <div className="h-2.5 rounded-full bg-gray-100" />
        </div>
      ))}
    </div>

    <div className="flex flex-1 flex-col gap-1 px-3 py-2">
      {COMPARATOR_ROWS.map((row) => (
        <div
          key={row}
          className="flex items-center justify-between rounded bg-gray-50 border border-gray-100 px-2 py-[3px]"
        >
          <span className="block h-4 w-24 rounded bg-gray-200" />
          <span className="block h-4 w-10 rounded bg-gray-200" />
        </div>
      ))}
    </div>
  </div>
);

export default FunnelCardSkeleton;
